/**
 *  RaceLadder
 *
 *  Created by Legman on 09/05/2017.
 *
 */

import Common from "./Common";
import RaceAvatar from "./RaceAvatar";

/**
 * @class
 * @extends PIXI.Container
 */
export default class RaceLadder extends PIXI.Container {
    constructor() {
        super();

        /**
         * @type {*}
         */
        this.signals = {};

        /**
         * @type {*}
         */
        this.signals.change = new signals.Signal();

        /**
         * @type {Array}
         * @private
         */
        this._avatars = [];

        /**
         * @type {number}
         * @private
         */
        this._spacing = 66;
    }

    /**
     */
    init() {
        const cars = Common.game.getCars();
        for (let i = 0; i < cars.length; ++ i) {
            const car = cars[i];
            const texture = RaceLadder.getAvatarTexture(car.id);
            const avatar = new RaceAvatar(car.id, texture, car);
            avatar.y = this._spacing * i;
            avatar.lastRacePos = i;
            this.addChild(avatar);
            this._avatars.push(avatar);
        }
    }

    /**
     * @param {function} [callback]
     * @param {*} [scope]
     */
    animateIn(callback, scope) {
    }

    /**
     * @param {function} [callback]
     * @param {*} scope
     */
    animateOut(callback, scope) {
    }

    /**
     */
    update() {
        this._avatars.sort(function(a, b) {
            return b.car.getTotalDistance() - a.car.getTotalDistance();
        });

        for (let i = 0; i < this._avatars.length; ++ i) {
            const avatar = this._avatars[i];
            avatar.y = this._spacing * i;
            avatar.setRacePos(i + 1);
            if (avatar.lastRacePos !== i) {
                avatar.lastRacePos = i;
                this.signals.change.dispatch(avatar, i)
            }
        }
    }

    /**
     * @param {number} type
     * @param {RaceCar} car
     * @param {boolean} hit
     */
    usePowerup(type, car, hit) {
        for (let i = 0; i < this._avatars.length; ++ i) {
            const avatar = this._avatars[i];
            if (avatar.car === car) {
                avatar.usePowerup(type, hit);
            }
        }
    }

    /**
     * @param {number} id
     * @returns {PIXI.Texture}
     */
    static getAvatarTexture(id) {
        const assets = Common.assets;
        const characters = Common.config.characters;
        for (let i = 0; i < characters.length; ++ i) {
            const character = characters[i];
            if (character.id === id) {
                return assets.getTexture(character.avatar.texture);
            }
        }
    }
}


